import { useLocation } from 'react-router-dom';

import { getPathParams } from 'shared_DEPRECATED/utils';
import { routeNames } from 'shared_DEPRECATED/utils/config';

import { SPRINT_TYPES } from '../config';

export const SPRINT_TYPE_MAP = {
  [routeNames.COACH]: SPRINT_TYPES.COACHED,
  [routeNames.CHALLENGE_TRACKING]: SPRINT_TYPES.MY,
  [routeNames.CONNECTIONS]: SPRINT_TYPES.SHARED,
} as const;

export const useSprintType = () => {
  const { pathname } = useLocation();
  let [firstPathParam] = getPathParams(pathname);

  return SPRINT_TYPE_MAP[firstPathParam];
};
